import { serializePaginatedQueryValues } from "@smartrr/shared/utils/paginatedQuery";
import moment from "moment";

import { loadOrders } from "@customer-app/state/actionCreators/orders";
import { store } from "@customer-app/state/store";

import { DEFAULT_PAGE_SIZE_FOR_ORDER, MIN_SELECTOR_YEAR } from "../constants";

export const handleChangeYear = (year: number, setYear: React.Dispatch<React.SetStateAction<number>>) => {
  setYear(year);
  return store.dispatch(
    loadOrders(
      serializePaginatedQueryValues({
        filterLike: { year: `${year}` },
        pageNumber: 0,
        pageSize: DEFAULT_PAGE_SIZE_FOR_ORDER,
      })
    )
  );
};

export const fetchOrdersRecursivelyInPastYears = (
  year: number,
  setYear: React.Dispatch<React.SetStateAction<number>>
) => {
  handleChangeYear(year, setYear)
    .then(res => {
      if ((res.type === "LOADED_ORDERS" && res.payload.orders.totalCount > 0) || year === MIN_SELECTOR_YEAR) {
        return;
      }
      fetchOrdersRecursivelyInPastYears(year - 1, setYear);
    })
    .catch(error => {
      console.error(error);
    });
};

export const generateYearSelectMenuItems = () => {
  const menuItems: { label: string; value: number }[] = [];

  const now = moment.utc();
  const currentYear = now.year();
  const maxYears = now.subtract(MIN_SELECTOR_YEAR, "years").year();

  for (let i = 0; i < maxYears; i++) {
    const val = currentYear - i;
    menuItems.push({ label: val.toString(), value: val });
  }

  return menuItems;
};

export const calculateDiscountPercentage = (basePrice: number, discountedPrice: number): string => {
  const discount = basePrice - discountedPrice;
  const discountPercentage = Math.round((discount / basePrice) * 100);

  return `${discountPercentage}%`;
};
